import React, { Component } from 'react';
import AuthNavbar from '../navigation/authnavigation.jsx'
import LeftLink from '../leftlink/leftlink.jsx'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import Recaptcha from 'react-recaptcha'
import RaisedButton from 'material-ui/RaisedButton';
import s from '../../services/allservices.jsx'
import '../../stylesheet/contactus.css'
import * as actions from '../../actions/actions.jsx'
import { connect } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import creditcardlogo from "../../images/credit-cards-vector-icon-.jpg";
// import services from '../../services/allservices.jsx'
import {
    Link, withRouter
} from 'react-router-dom';
import LoaderSmall from "../loader/loadersmall.jsx"
// import kapcha from '../../images/Kaptcha.jpg'
import Loader from '../loader/loader.jsx'

const styles = {
    button: {
        margin: 12,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};

const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        cardState: state.getCardReducer.cardState,
        contactUsSubjectState: state.contactUsSubjectReducer.contactUsSubjectState,
    })
const mapDispatchToProps = dispatch =>
    ({
        fetchCard(state) {
            dispatch(
                actions.getCardAction(state)
            )
        },
        getContactSubject() {
            dispatch(
                actions.contactSubjectAction()
            )
        }
    })
const JSEncrypt = window.JSEncrypt


var callback = function () {

};

// specifying verify callback function
var verifyCallback = function (response) {

};

// specifying verify callback function
// var verifyCallback = function (response) {
//     let state = {
//         "g-recaptcha-response": response
//     }

//     fetch(s.capcha, {
//         method: "POST",
//         headers: {
//             'content-type': 'application/json'
//         },
//         body: { "g-recaptcha-response": response }
//     })
//         .then(res => {

//         })
// };

class AuthContactUs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            capcha: '',
            response: "",
            firstName: "",
            lastName: "",
            comments: "",
            emailId: "",
            subject: 1,
            disabled: true,
            correctEmail: true,
            correctphone:true,
            cardDetailsId: 1,
            selectedCard: [],
            mobileNumber: ""


        }
        // this.handleCapcha = this.handleCapcha.bind(this)
    }
    // handleSelect1 = (event, index, value) => {
    //     this.setState({ cardDetailsId: value }, () => { this.props.fetchCardActivity(this.state.cardDetailsId, this.state.activityFromDate, this.state.activityToDate, this.state.statementPeriod) });

    // }

    handleSelect1 = (event, index, value) => {

        const { cardState } = this.props
        
        let _this = this

        this.setState({ cardDetailsId: value }, () => {
            for (let i = 0; i < cardState.body.length; i++) {
                if (this.state.cardDetailsId === cardState.body[i].cardDetailsId) {
              
                    this.setState({

                        selectedCard: cardState.body[i]
                    }, () => {

                        const { response } = this.state

                       
                        let _this = this
                        if (response !== '') {
                            const state = {
                                cardDetailsId: _this.state.cardDetailsId,
                                firstName: _this.state.firstName,
                                lastName: _this.state.lastName,
                                comments: _this.state.comments,
                                emailId: _this.state.emailId,
                                subject: _this.state.subject,
                                mobileNumber: _this.state.mobileNumber,
                            }
                            fetch(s.contact_us + "/?g-recaptcha-response=" + response, {
                                method: 'POST',
                                headers: new Headers({
                                    'Content-Type': 'application/json',
                                }),
                                body: JSON.stringify(state)
                            })
                                .then(res => {
                                    if (res.status === 200 || res.status === 201) {

                                    } else {
                                    }
                                })
                        }

                    })
                }
            }
        });

    }
   
    
    componentWillReceiveProps(nextProps) {
        
       
       try {
           if (nextProps.cardState && nextProps.cardState.length !== 0) {
               this.setState({
                   loader: false,

                   selectedCard: nextProps.cardState.body[0],
                   mobileNumber: nextProps.cardState.body[0].mobileNumber,
                   firstName: nextProps.cardState.body[0].firstName,
                   lastName: nextProps.cardState.body[0].lastName,
                   emailId: nextProps.cardState.body[0].emailId,

                //    mobileNumber: nextProps.cardState.body[0].mobileNumber
               },()=>{
                   
               }
           )
           }
       } catch (e) {

       }

   }
    componentDidMount() {
        this.props.getContactSubject()
        this.setState({
            cardDetailsId: this.props.cardState.body[0].cardDetailsId,
            mobileNumber:  this.props.cardState.body[0].mobileNumber,         
            firstName: this.props.cardState.body[0].firstName,
            lastName: this.props.cardState.body[0].lastName,
            emailId: this.props.cardState.body[0].emailId,
        })
        // const { response } = this.state

        const { publicKey } = this.props
        let _this = this
        setTimeout(function () {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);


                const state = {
                    applicationId: "gmcabs",
                    accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                }
                _this.props.fetchCard(state)
            }
        }, 500);

      
        // let _this = this
        // if (response !== '') {
        //     const state = {
        //         cardDetailsId: this.state.cardDetailsId,
        //         firstName: this.state.firstName,
        //         lastName: this.state.lastName,
        //         comments: this.state.comments,
        //         emailId: this.state.emailId,
        //         subject: this.state.subject,
        //         mobileNumber: this.state.mobileNumber,
        //     }
        //     fetch(s.contact_us + "/?g-recaptcha-response=" + response, {
        //         method: 'POST',
        //         headers: new Headers({
        //             'Content-Type': 'application/json',
        //         }),
        //         body: JSON.stringify(state)
        //     })
        //         .then(res => {
        //             if (res.status === 200 || res.status === 201) {

        //             } else {
        //             }
        //         })
        // }
    }
    handleSelect = (event, index, value) => this.setState({ subject: value });

    handelemail = (e, value) => {
       
        if (e.target.name === "emailId" && value.length !== 0) {
            if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,40}))$/.test(e.target.value)) {
                this.setState({
                    correctEmail: true,
                    emailId: value,

                }, () => {
                    if (this.state.firstName.length !== 0 && this.state.lastName.length !== 0 && this.state.emailId.length !== 0 && this.state.subject.length !== 0 && this.state.mobileNumber.length !== 0) {
                        this.setState({
                            disabled: false
                        })
                    } else {
                        this.setState({
                            disabled: true
                        })
                    }
                })
            } else {
                this.setState({
                    correctEmail: false,

                })
            }
        }
        else {
            this.setState({
                disabled: true
            })
        }
    }

    handelmobileNumber = (e, value) => {
       
        if (e.target.name === "mobileNumber" && value.length !== 0) {
            if (/^(?!.*-.*-.*-)(?=(?:.{8,10}$)|(?:(?=.{9,11}$)[^-]*-[^-]*$)|(?:(?=.{10,12}$)[^-]*-[^-]*-[^-]*$)  )[\d-]+$/.test(value)) {
                this.setState({
                    correctphone: true,
                    mobileNumber: value,

                }, () => {
                    if (this.state.firstName.length !== 0 && this.state.lastName.length !== 0 && this.state.emailId.length !== 0 && this.state.subject.length !== 0 && this.state.mobileNumber.length !== 0) {
                        this.setState({
                            disabled: false
                        })
                    } else {
                        this.setState({
                            disabled: true
                        })
                    }
                })
            } else {
                this.setState({
                    correctphone: false,

                })
            }
        }
        else {
            this.setState({
                disabled: true
            })
        }
    }

    handleLastName = (e, value) => {
       
        if (value.length !== 0) {
            this.setState({
                lastName: value
            }, () => {
                if (this.state.firstName.length !== 0 && this.state.lastName.length !== 0 && this.state.emailId.length !== 0 && this.state.subject.length !== 0 && this.state.mobileNumber.length !== 0) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
        }else {
            this.setState({
                disabled: true
            })
        }
    }

    handleFirstName = (e, value) => {
       
        if (value.length !== 0) {
            this.setState({
                firstName: value
            }, () => {
                if (this.state.firstName.length !== 0 && this.state.lastName.length !== 0 && this.state.emailId.length !== 0 && this.state.subject.length !== 0 && this.state.mobileNumber.length !== 0) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
        }else {
            this.setState({
                disabled: true
            })
        }
    }
    handleComments = (e, value) => {
       
        if (value.length !== 0) {
            this.setState({
                lastName: value
            }, () => {
                if (this.state.firstName.length !== 0 && this.state.lastName.length !== 0 && this.state.emailId.length !== 0 && this.state.subject.length !== 0 && this.state.mobileNumber.length !== 0) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
        }else {
            this.setState({
                disabled: true
            })
        }
    }
    handlesubject = (event, index, value1) => {
      
        this.setState({
            gender: value1,
            genderSelected: true
        }, () => {
            if (this.state.firstName.length !== 0 && this.state.lastName.length !== 0 && this.state.emailId.length !== 0 && this.state.subject.length !== 0 && this.state.mobileNumber.length !== 0) {
                this.setState({
                    disabled: false
                })
            } else {
                this.setState({
                    disabled: true
                })
            }
        });
    }
    onChange= (e , value) => {

        if (e.target.name === "firstName" || e.target.name === "lastName" || e.target.name === "comments" || e.target.name === "emailId" || e.target.name === "subject" || e.target.name === "mobileNumber") {
            if (e.target.name === "emailId") {
                if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,40}))$/.test(e.target.value)) {
                    this.setState({
                        correctEmail: true,
                        emailId: value,
                        disabled: false,
                    })
                } else {
                    this.setState({
                        correctEmail: false,
                        disabled: true,
                    })
                }
            } 
        
            if (e.target.name === "mobileNumber") {
                if (/^[0-9]{8,15}$/.test(value)) {
                    this.setState({
                        correctphone: true,
                        mobileNumber: value,
                        disabled: false,
                    })
                } else {
                    this.setState({
                        correctphone: false,
                        disabled: true,
                    })
                }
            } 
        
            this.setState({
                [e.target.name]: e.target.value
            }, () => {

                const { firstName, lastName, comments, subject, emailId, mobileNumber } = this.state
            
                if (firstName !== "" && lastName !== "" && comments !== "" && subject !== "" && emailId !== "" && mobileNumber !== "") {
                    
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
        }        
        
}

    onchangemobile = (e,value) =>{
        this.setState({ [e.target.name]: e.target.value })
    }
    
    onChangeemail = (e, value) => {
        if (e.target.name === "emailId") {
            if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,40}))$/.test(e.target.value)) {
                this.setState({
                    correctEmail: true,
                    emailId: value,
                    disabled: false,
                })
            } else {
                this.setState({
                    correctEmail: false,
                    disabled: true,
                })
            }
        } else {
            this.setState({
                [e.target.name]: e.target.value
            })
        }

    }
    verifyCallback = response => {
        this.setState({
            response: response

        }, () => {
          
        })
    }

    handleSubmit = () => {
        const { response ,correctEmail ,correctphone} = this.state
        if (correctEmail === false) {
            this.setState({
                correctEmail: false
            })
        }
        else if (correctphone === false) {
            this.setState({
                correctphone: false
            })
        }
        
        else {
       
      
        let _this = this
        if (response !== '') {
            const state = {
                cardDetailsId: this.state.cardDetailsId,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                comments: this.state.comments,
                emailId: this.state.emailId,
                subject: this.state.subject,
                mobileNumber: this.state.mobileNumber,
            }

           
            this.setState({
                loader: true
            })

            fetch(s.contact_us + "/?g-recaptcha-response=" + response, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                }),
                body: JSON.stringify(state)
            })
                .then(res => {
                    if (res.status === 200 || res.status === 201) {
                        toast.success(res.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                        this.setState({
                            loader: false
                        })
                        setTimeout(function () {
                            window.location.reload(1);
                        }, 3000);
                        
                    } else {

                        toast.error(res.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });


                    }
                })
            }
        }
    }

    // verifyCallback = response => {
   
    //     this.setState({
    //         "g-recaptcha-response": response
    //     }, () => {
    //         let state = {
    //             "response": response
    //         }
    //         fetch(s.capcha + "/?g-recaptcha-response=" + response, {
    //             method: "POST",
    //             headers: {
    //                 'content-type': 'application/json'
    //             },
    //             body: JSON.stringify(state)
    //         })
    //             .then(res => {
  
    //             })
    //     })


    // }
    render() {
        const { cardState,contactUsSubjectState } = this.props
        const { cardDetailsId,correctphone, selectedCard, correctEmail ,firstName,lastName,emailId,mobileNumber } = this.state
        return (
            <div className="row">
                <ToastContainer
                    draggablePercent={60}
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable={false}
                    pauseOnHover
                />
                <div className="col-sm-12">
                    <AuthNavbar />
                </div>

                <div className="container " style={{ marginTop: "80px" }}>
                    <div className="row" >
                        <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                            <LeftLink />
                        </div>
                        <div className="col-sm-9 bg-white authcontactus" style={{ padding: "0px 30px" }}>
                            <div className="row">
                                <div className="col-sm-12 text-center">
                                    <h4>Contact Us</h4>
                                </div>
                            </div>
                            {cardState.status === 200 && cardState.body.length !== 0 && selectedCard.length !== 0 ?
                            <div className="col-sm-12">
                            <div className="row input-group" >
                                <div className="offset-md-1 col-sm-5">
                                    <div className="row">
                                        <div className="col-sm-2 input-icon" >
                                            <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                        </div>
                                        <div className="col-sm-10" >
                                            <TextField
                                                hintText="Type Your First Name"
                                                floatingLabelText="First Name"
                                                type="text"
                                                name="firstName"
                                                defaultValue={firstName || null }
                                                maxLength="30"
                                                className="input-width required"
                                                onChange={this.onChange}
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle} />

                                        </div>
                                    </div>

                                </div>
                                <div className="col-sm-5">
                                    <div className="row">
                                        <div className="col-sm-2 input-icon" >
                                            <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                        </div>
                                        <div className="col-sm-10" >
                                            <TextField
                                                hintText="Type Your Last Name"
                                                floatingLabelText="Last Name"
                                                type="text"
                                                for="choose"
                                                defaultValue={lastName || null }
                                                name="lastName"
                                                maxLength="30"
                                                className="input-width required"
                                                onChange={this.onChange}
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="row input-group" >
                                <div className="offset-md-1 col-sm-5">
                                    <div className="row">
                                        <div className="col-sm-2 emailinput" >
                                            <i className="fa fa-envelope text-dark " aria-hidden="true"></i>
                                        </div>
                                        <div className="col-sm-10" >
                                            <TextField
                                                hintText="Start Typing"
                                                floatingLabelText="E-Mail"
                                                type="text"
                                                name="emailId"
                                                maxLength="50"
                                                className="input-width required"
                                                defaultValue={emailId || null }
                                                onChange={this.onChange}
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                errorText={correctEmail ? null : "Not a valid email"}
                                            />
                                        </div>
                                    </div>

                                </div>
                                <div className="col-sm-5">
                                    <div className="row input-group" >
                                        <div className="col-sm-2 input-icon" >
                                            <i className="fa fa-thumb-tack" aria-hidden="true"></i>
                                        </div>
                                        <div className="col-sm-10">
                                            <SelectField
                                            style={{width:"243px"}} 
                                                floatingLabelText="Select Subject"
                                                className=" required"
                                                value={this.state.subject}
                                                onChange={this.handleSelect}
                                                name="subject"
                                            >
                                               {(this.props.contactUsSubjectState.length !== 0 && this.props.contactUsSubjectState.status === 200) ?
                                                         this.props.contactUsSubjectState.body && this.props.contactUsSubjectState.body.map((value, i) =>
                                                           <MenuItem value={(JSON.parse(this.props.contactUsSubjectState.body[i].subjectId))} primaryText={contactUsSubjectState.body[i].description} />
                                                      )
                                                      :
                                                     <div></div>
                                                    }
                                            </SelectField>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                                <div className="row input-group" >

                                    <div className="offset-md-1 col-sm-5">
                                        <div className="row input-group" >
                                            <div className="col-sm-2 input-icon" >
                                                <img src={creditcardlogo} alt="" />
                                            </div>
                                            <div className="col-sm-10" >

                                                <SelectField
                                                    floatingLabelText="Card Number"
                                                    style={{width:"243px"}} 
                                                    onChange={this.handleSelect1}
                                                    className="input-width "
                                                    name="Selected Card "
                                                    className="required"
                                                    value={cardDetailsId}>
                                                    {cardState.body.map((value, i) =>
                                                        <MenuItem value={cardState.body[i].cardDetailsId} primaryText={cardState.body[i].cardNumber} key={i} />
                                                    )}
                                                </SelectField>


                                            </div>
                                        </div>
                                    </div>

                                    <div className=" col-sm-5">

                                        <div className="row">
                                            <div className="col-sm-2 mobileinput" >
                                                <i className="fa fa-mobile text-dark " aria-hidden="true"></i>
                                            </div>
                                            <div className="col-sm-10"  >
                                            
                                                <TextField
                                                   
                                                    hintText="Enter Mobile Number"
                                                    floatingLabelText="Mobile Number"
                                                    type="number" step="1"
                                                    name="mobileNumber"
                                                    onInput={(e) => {
                                                        e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 15)
                                                    }}
                                                    defaultValue={mobileNumber || null }                
                                                    className="input-width required"
                                                    onChange={this.onChange}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle} 
                                                    errorText={correctphone ? null :  "Not a valid phone number"  }/>                                                  
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            <div className="row input-group" >
                                <div className="offset-md-1 col-sm-5">
                                    <div className="row">
                                        <div className="col-sm-2 input-icon" >
                                            <i className="fa fa-comment text-dark " aria-hidden="true"></i>
                                        </div>
                                        <div className="col-sm-10" >
                                            <TextField
                                                hintText="Write Your Comment"
                                                floatingLabelText="Comments"
                                                multiLine={true}
                                                className="input-width required"
                                                name="comments"
                                                rows={1}
                                                onChange={this.onChange}
                                                maxLength="1000"
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                            />
                                        </div>
                                    </div>

                                </div>
                                <div className="offset-md-1 col-sm-5">
                                    <div className="row">
                                        <div className="col-sm-12 text-center margin-capcha">
                                            <Recaptcha
                                                sitekey="6LeRorofAAAAACriDJ7aN2WI9LOCRz8aN2KzqU3C"
                                                render="explicit"
                                                verifyCallback={this.verifyCallback}
                                                onloadCallback={callback}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="offset-sm-4 col-sm-3">
                                    <RaisedButton
                                        label="Submit"
                                        className="pull-right"
                                        // style={styles.button}
                                        backgroundColor="#333"
                                        labelColor="#fff"
                                        id="submit"
                                        disabled={this.state.disabled}
                                        onClick={this.handleSubmit}
                                        style={{ marginTop: "48px" }}
                                    />
                                </div>{this.state.loader === true &&
                               <div className="col-sm-1" style={{ marginTop:"20px", width: "30% !mportant" }} >
                               <LoaderSmall/>
                                </div>}
                            </div>
                        </div>: <Loader />}
                    </div>
                </div>
            </div>
            </div>
        );
    }
}
AuthContactUs.defaultProps = {
    cardState: {
        status: 600
    },

};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthContactUs));


// WEBPACK FOOTER //
// ./src/components/contactus/authcontactus.jsx